import { createContext, useContext, useState, type ReactNode } from 'react';

import { createSimulatorClient, type SimulatorClient } from './client';

const ApiContext = createContext<SimulatorClient | null>(null);

/** Creates the control API's client once. */
export function ApiClientProvider({ children }: { children: ReactNode }) {
  const [client] = useState(() => createSimulatorClient());
  return <ApiContext value={client}>{children}</ApiContext>;
}

/**
 * The typed control API client:
 *
 *   const client = useApiClient();
 *   const status = await unwrap(client.GET('/simulation/status'));
 */
export function useApiClient(): SimulatorClient {
  const client = useContext(ApiContext);
  if (client === null) {
    throw new Error('useApiClient must be used inside <ApiClientProvider>');
  }
  return client;
}
